module.exports = __webpack_public_path__ + "static/media/logo_oevs.311b8924.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/customerexpert/logo_oevs.png
// module id = 226
// module chunks = 0